import React, { Component } from "react"
import styled, { keyframes } from "styled-components";


const Dash = (props:Props) => keyframes`
0% {
    stroke-dasharray: 326.7256359733385 326.7256359733385;
    stroke-dashoffset: 326.7256359733385px;
    stroke:${props.colorStart};
  }


  100% {
    stroke-dasharray:  326.7256359733385 326.7256359733385;
    stroke-dashoffset: 0;
    stroke:${props.colorEnd};
  }
`;

const Circle = styled.circle` 
    animation: ${(props:Props)=>Dash(props)} 2s ease infinite; 
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
`
type Props = {
    colorStart:string
    colorEnd:string
    // radius: number,
    // stroke: number,
    // progress:number
}

export class ProgressRing extends Component<Props> {
    normalizedRadius:number
    circumference:number
    constructor(props:Props) {
        super(props);
        const { radius, stroke } = {radius:60,stroke:4};
        this.normalizedRadius = radius - stroke * 2;
        this.circumference = this.normalizedRadius * 2 * Math.PI;
    }
    render() {
        const { radius, stroke } = {radius:60,stroke:4}
        // const strokeDashoffset = this.circumference - progress / 100 * this.circumference;

      
        return (
          <svg
            height={radius * 2}
            width={radius * 2}
            >
            <Circle
                colorStart = {this.props.colorStart}
                colorEnd = {this.props.colorEnd}
              fill="transparent"
              strokeWidth={ stroke }

              stroke-width={ stroke }
              r={ this.normalizedRadius }
              cx={ radius }
              cy={ radius }
              />
          </svg>
        );
      }
}
